import React from "react"
import {Grid, GridColumn} from "@progress/kendo-react-grid"
import {useAppSelector} from "../../../store"
import {RootState} from "../../../rootReducer"
import {SpinnerGrid} from "../../../shared/CommonItems"

const TestsGrid = () => {
    const testsData = useAppSelector((state: RootState) => state.containers.dvsaTest.testsData)
    const testsLoading = useAppSelector((state: RootState) => state.containers.dvsaTest.testsLoading)

    return (
        <div className="position-relative">
            {testsLoading && <SpinnerGrid />}
            <Grid
                style={{
                    height: "calc(((100vh - 14rem) * 0.33) - 25px)",
                }}
                data={testsData}
            >
                <GridColumn field="testCode" title="Test Code" />
                <GridColumn field="testName" title="Test" />
            </Grid>
        </div>
    )
}

export default TestsGrid
